import { api } from './api';

export interface UploadedFile {
  id: string;
  originalName: string;
  filename: string;
  mimetype: string;
  size: number;
  uploadedAt: Date;
  fieldName?: string;
  url?: string;
  storagePath?: string;
}

export interface UploadResponse {
  success: boolean;
  files?: UploadedFile[];
  error?: string;
}

interface UploadFilesPayload {
  primaryImage?: File | null;
  secondaryImage?: File | null;
}

export const uploadService = {
  // Upload one or two image files
  async uploadFiles(payload: UploadFilesPayload): Promise<UploadResponse> {
    const formData = new FormData();
    if (payload.primaryImage) {
      formData.append('primaryImage', payload.primaryImage);
    }
    if (payload.secondaryImage) {
      formData.append('secondaryImage', payload.secondaryImage);
    }
    
    if (!payload.primaryImage && !payload.secondaryImage) {
      throw new Error('At least one file must be provided for upload.');
    }

    const response = await api.post<UploadResponse>('/api/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    console.log('Upload response:', response.data);
    return response.data;
  },
  
  // Delete uploaded file
  async deleteFile(fileId: string): Promise<void> {
    await api.delete(`/api/upload/${fileId}`);
    console.log(`File ${fileId} deleted`);
  }
};
